import { render } from "./CollaborationFeebackPopup.vue?vue&type=template&id=655e4b19"
import script from "./CollaborationFeebackPopup.vue?vue&type=script&lang=js"
export * from "./CollaborationFeebackPopup.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__